query getPendingDowngrade($companyId: ID!) {
  pendingDowngrade: getPendingDowngrade(companyId: $companyId) {
    productType
    downgradeAt
  }
}
